export default (element: HTMLElement) => {
  const button = element.querySelector<HTMLButtonElement>(
    '[data-component-role="scrollButton"]',
  );

  if (!button) {
    console.error('Scroll button not found');
    return;
  }

  // Show/hide button based on scroll position
  const handleScroll = () => {
    const scrollThreshold = window.innerHeight * 0.5;
    const show = window.scrollY > scrollThreshold;
    button.classList.toggle('scrollUpButton--hidden', !show);
  };

  // Scroll to top on click
  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  // Listen to scroll events
  window.addEventListener('scroll', handleScroll, { passive: true });

  // Check initial scroll position
  handleScroll();
};
